import api from './api';
import StorageService from './StorageService';

const PettyCashService = {
    getAllPettyCash: async (page = 1, limit = 10, filters = {}) => {
        try {
            const { branchId, staffId, memberId, vendorId, projectId, expenditureTypeId, paymentMode, status, startDate, endDate } = filters;
            let url = `/petty-cash?page=${page}&limit=${limit}`;
            if (branchId) url += `&branchId=${branchId}`;
            if (staffId) url += `&staffId=${staffId}`;
            if (memberId) url += `&memberId=${memberId}`;
            if (vendorId) url += `&vendorId=${vendorId}`;
            if (projectId) url += `&projectId=${projectId}`;
            if (expenditureTypeId) url += `&expenditureTypeId=${expenditureTypeId}`;
            if (paymentMode) url += `&paymentMode=${paymentMode}`;
            if (status) url += `&status=${status}`;
            if (startDate) url += `&startDate=${startDate}`;
            if (endDate) url += `&endDate=${endDate}`;

            const res = await api.get(url);
            return res.data;
        } catch (error) {
            if (error.response && error.response.data) {
                throw new Error(error.response.data.message || 'Failed to fetch petty cash records');
            }
            throw new Error('Unable to connect to server');
        }
    },

    getPettyCashById: async (id) => {
        try {
            const res = await api.get(`/petty-cash/${id}`);
            return res.data;
        } catch (error) {
            if (error.response && error.response.data) {
                throw new Error(error.response.data.message || 'Failed to fetch petty cash record');
            }
            throw new Error('Unable to connect to server');
        }
    },

    createPettyCash: async (data) => {
        try {
            const payload = { ...data, createdBy: StorageService.loginData()?.employeeId };
            const res = await api.post('/petty-cash', payload);
            return res.data;
        } catch (error) {
            if (error.response && error.response.data) {
                throw new Error(error.response.data.message || 'Failed to create petty cash');
            }
            throw new Error('Unable to connect to server');
        }
    },

    createBulkPettyCash: async (transactions) => {
        try {
            const payload = { transactions: transactions.map(tx => ({ ...tx, createdBy: StorageService.loginData()?.employeeId })) };
            const res = await api.post('/petty-cash/bulk', payload);
            return res.data;
        } catch (error) {
            if (error.response && error.response.data) {
                throw new Error(error.response.data.message || 'Failed to create petty cash in bulk');
            }
            throw new Error('Unable to connect to server');
        }
    },

    updatePettyCash: async (id, data) => {
        try {
            const payload = { ...data, updatedBy: StorageService.loginData()?.employeeId };
            const res = await api.put(`/petty-cash/${id}`, payload);
            return res.data;
        } catch (error) {
            if (error.response && error.response.data) {
                throw new Error(error.response.data.message || 'Failed to update petty cash');
            }
            throw new Error('Unable to connect to server');
        }
    },

    getPettyCashStats: async (filters = {}) => {
        try {
            const { branchId, createdBy, staffId, memberId, vendorId, projectId, expenditureTypeId, paymentMode, status, startDate, endDate } = filters;
            let url = '/petty-cash/stats?';
            if (branchId) url += `branchId=${branchId}&`;
            if (createdBy) url += `createdBy=${createdBy}&`;
            if (staffId) url += `staffId=${staffId}&`;
            if (memberId) url += `memberId=${memberId}&`;
            if (vendorId) url += `vendorId=${vendorId}&`;
            if (projectId) url += `projectId=${projectId}&`;
            if (expenditureTypeId) url += `expenditureTypeId=${expenditureTypeId}&`;
            if (paymentMode) url += `paymentMode=${encodeURIComponent(paymentMode)}&`;
            if (status) url += `status=${encodeURIComponent(status)}&`;
            if (startDate) url += `startDate=${startDate}&`;
            if (endDate) url += `endDate=${endDate}&`;
            const res = await api.get(url);
            return res.data;
        } catch (error) {
            if (error.response && error.response.data) {
                throw new Error(error.response.data.message || 'Failed to fetch petty cash statistics');
            }
            throw new Error('Unable to connect to server');
        }
    },

    updateStatus: async (id, status) => {
        try {
            const res = await api.patch(`/petty-cash/${id}/status`, { status, updatedBy: StorageService.loginData()?.employeeId });
            return res.data;
        } catch (error) {
            if (error.response && error.response.data) {
                throw new Error(error.response.data.message || 'Failed to update petty cash status');
            }
            throw new Error('Unable to connect to server');
        }
    }
};

export default PettyCashService;
